import {ChangeDetectorRef, Component, ViewChild, ViewEncapsulation} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CcBaseComponent} from "../../../crystal-elements/cc-base.component";
import {SyncService} from "../../../services/support/sync.service";
import {FormFieldGroupConfig} from "../../../model/api/form-field-group-config";
import {FormFieldConfig} from "../../../model/api/form-field-config";
import {CcFormComponent} from "../../../crystal-elements/form-dialog/form/cc-form.component";
import TYPE = FormFieldConfig.TYPE;
import {Observable} from "rxjs";
import {ApiValidation} from "../../../model/api/api-validation";
import {FieldRecord} from "../../../model/api/field-record";
import {GatewayConnection} from "../../../model/hub/gateway-connection";
import {FieldsService} from "../../../services/common/fields-service";
import {ProgressTracker} from "../../../model/api/progress-tracker";

@Component({
  templateUrl: './sync.component.html',
  styleUrls: ['./sync.component.scss'],
  selector: 'app-sync',
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class SyncComponent extends CcBaseComponent {

  loading: boolean = false;
  transPartKey: string = 'support.sync';
  formConfig: FormFieldGroupConfig[];
  formRecord: { "selectGwId": undefined } = {"selectGwId": undefined};

  connectedGwsFields: FieldRecord<GatewayConnection[]>[] = [];

  @ViewChild('ccForm')
  public ccForm: CcFormComponent;

  loadingProgressValue: number = 0;
  tracker: ProgressTracker;

  constructor(cdref: ChangeDetectorRef,
              protected syncService: SyncService,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService,
              private readonly fieldsService: FieldsService) {
    super(cdref, messageService, translateService);
  }

  protected initConfigs() {
    super.initConfigs();

    // <p-button [label]="'page.' + this.transPartKey + '.buttons.force_sync' | translate" icon="pi pi-sync" class="mr-2"
    // (onClick)="doSync()"></p-button>
    // <p-button [label]="'page.' + this.transPartKey + '.buttons.force_sync_statics' | translate" icon="pi pi-sync"
    // class="mr-2" (onClick)="doSyncStatics()"></p-button>
    // <p-button [label]="'page.' + this.transPartKey + '.buttons.force_sync_publisher' | translate" icon="pi pi-sync"
    // class="mr-2" (onClick)="doSyncPublisher()"></p-button>
    this.formConfig = [
      {
        group: 'web_sync',
        fields: [
          {
            column: 3,
            type: TYPE.BUTTONS,
            buttons: [{
              icon: 'pi pi-sync',
              class: 'p-button-warning',
              label: this.getTranslation('page.' + this.transPartKey + '.buttons.force_sync'),
              command: event => {
                this.doSync();
              },
            }]
          },
          {
            column: 9,
            type: TYPE.BUTTONS,
          },
          {
            column: 3,
            type: TYPE.BUTTONS,
            buttons: [{
              icon: 'pi pi-sync',
              class: 'p-button-warning',
              label: this.getTranslation('page.' + this.transPartKey + '.buttons.force_sync_statics'),
              command: event => {
                this.doSyncStatics();
              },
            }]
          },
          {
            column: 9,
            type: TYPE.BUTTONS,
          },
          {
            column: 3,
            type: TYPE.BUTTONS,
            buttons: [{
              icon: 'pi pi-sync',
              class: 'p-button-warning',
              label: this.getTranslation('page.' + this.transPartKey + '.buttons.force_sync_publisher'),
              command: event => {
                this.doSyncPublisher();
              },
            }]
          },
          {
            column: 9,
            type: TYPE.BUTTONS,
          },
        ]
      },
      {
        group: 'gw_sync',
        fields: [
          {
            column: 3,
            type: TYPE.BUTTONS,
            buttons: [{
              icon: 'pi pi-sync',
              class: 'p-button-danger',
              label: this.getTranslation('page.' + this.transPartKey + '.buttons.all_gw_sync'),
              command: event => {
                this.doAllGwSync();
              },
            }]
          },
          {
            column: 9,
            type: TYPE.BUTTONS,
          },
          {
            column: 3,
            type: TYPE.BUTTONS,
            buttons: [{
              icon: 'pi pi-sync',
              class: 'p-button-danger',
              label: this.getTranslation('page.' + this.transPartKey + '.buttons.single_gw_sync'),
              command: event => {
                this.doSingleGwSync();
              },
              disabledFct:record => !record.selectGwId
            }]
          },
          {
            field: 'selectGwId',
            column: 2,
            class: 'gw-select',
            type: TYPE.DROPDOWN,
            options: () => this.connectedGwsFields,
          },
          {
            column: 7,
            type: TYPE.BUTTONS,
          },
        ]
      }
    ];
    this.ccForm.reloadFieldValueMap();
  }

  protected initData() {
    super.initData();
    this.loadingProgressValue = 0;

    this.tracker = this.fieldsService.createTracker();

    this.tracker.progress.subscribe(value => {
      this.loadingProgressValue = value;
      this.ccForm.reloadFieldValueMap();
    });
    this.fieldsService.loadField(this.connectedGwsFields, () => this.syncService.getConnectedGws(), this.tracker);
  }

  public doSync(): void {
    this.runSync(() => this.syncService.doSync());
  }

  public doSyncStatics(): void {
    this.runSync(() => this.syncService.doSyncStatics());
  }

  public doSyncPublisher(): void {
    this.runSync(() => this.syncService.doSyncPublisher());
  }

  public doAllGwSync(): void {
    this.runSync(() => this.syncService.doSyncAllGw());
  }

  public doSingleGwSync(): void {
    this.runSync(() => this.syncService.doSyncSingleGw(this.formRecord.selectGwId));
  }

  private runSync(action: () => Observable<ApiValidation<any>>): void {
    this.loading = true;

    action().subscribe(result => {
      result.success
        ? this.infoMessage(result.message)
        : this.errorMessage(result.message);

      this.loading = false;
    });
  }
}
